//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import work_bench_item from "@/components/work_bench_item";
import WxjsSdk from "@/Manager/10.Tms/ProductSnManager";
import passageUserManager from "@/Manager/09.Cm/PassageUserManager";
import NoticeMsage from "@/components/NoticeAnnouncement/Notice.vue";
import "@/assets/css/reset.css";
import "@/assets/css/global.css";

export default {
  components: { 
  work_bench_item,
  "notice-msage":NoticeMsage
   },
  data() {
    return {
      passageUser: {},
      actionTitle: "",
      actionList: [],
      showActionSheet: false,
      actionSheet1: {
        title: "选择入库方式",
        actions: [
          {
            name: "基于订单入库",
            // url: "/mSms/stockInByScan"
            url: this.$api.host + "/mSms/ShopStockInByDealerOutOrder/Index"
          },
          {
            name: "采购入库",
            //  url: "/mSms/stockInByScan"
            url: this.$api.host + "/mSms/ShopStockInBuyOrder/Scan2"
          }
        ]
      },
      actionSheet2: {
        title: "选择出库方式",
        actions: [
          {
            name: "1.销售出库[帮积分]",
            //url: "/mSms/stockOutWithPoints"
            url: this.$api.host + "/mSms/PrizeStockOutProductOrder/Check"
          },
          {
            name: "2.销售出库[无积分]",
            //url: "/mSms/stockOutNoPoints"
            url: this.$api.host + "/mSms/ShopStockOutSalesOrder/SetTo"
          },
          {
            name: "3.退货出库",
            //url: "/mSms/stockOutReturn"
            url: this.$api.host + "/mSms/ShopStockOutReturnOrder/SetTo"
          }
        ]
      },
      actionSheet3: {
        title: "选择核销方式",
        actions: [
          {
            name: "扫码核销",
            callback: function() {
              wx.scanQRCode({
                needResult: 0,
                scanType: ["qrCode"],
                success: res1 => {
                  console.log("开始扫码", res1);
                },
                fail: err => this.err_toast(err)
              });
            }
          },
          {
            name: "查看核销记录",
            //url: "/mMis/memberCouponSheet"
            url: this.$api.host + "/mMis/MemberCouponOrder/Index"
          }
        ]
      },

      actionSheet4: {
        title: "选择配送方式",
        actions: [
          {
            name: "门店自提",
            url:
              this.$api.host + "/mSms/MemberPointsOutExchangeOrderForShop/Check"
          },
          {
            name: "地址邮寄",
            url: this.$api.host + "/mSms/MemberPointsOutExchangeOrder/Check"
          }
        ]
      },

      work_bench_item1: [
        {
          img: "images/1_15.png",
          text: "我要入库",
          action: "checkin"
        },
        {
          img: "images/1_19.png",
          text: "我要出库",
          action: "checkout"
        },
        {
          img: "images/1_23.png",
          text: "我要盘点",
          // link: "/mSms/stockCheckScan",
          link: this.$api.host + "/mSms/ShopStockCheckOrder/Scan2",
          hide_border: true
        }
      ],
      // work_bench_item2: [
      //   {
      //     img: "images/2_10.png",
      //     text: "优惠券核销",
      //     hide_border: true,
      //     action: "checkCoupon"
      //   }
      // ],
      work_bench_item3: [
        {
          img: "images/3_06.png",
          text: "帮积分",
          // link: "/mSms/helpEarnPoints"
          link: this.$api.host + "/mSms/PrizeStockOutProductOrder/Check"
        },
        {
          img: "images/n_03.png",
          text: "帮兑换",
          // link: "/mSms/helpExchange"
          link: this.$api.host + "/mSms/MemberPointsOutExchangeOrder/Check"
        },
        {
          img: "images/3_08.png",
          text: "帮注册",
          // link: "/mSms/helpRegister",
          link: this.$api.host + "/mSms/Member/Register",
          hide_border: true
        }
      ],
      work_bench_item7: [
        {
          img: "images/3_06.png",
          text: "帮积分",
          // link: "/mSms/helpEarnPoints"
          link: this.$api.host + "/mSms/PrizeStockOutProductOrder/Check"
        },
        {
          img: "images/n_03.png",
          text: "帮兑换",
          // link: "/mSms/helpExchange"
          // link: this.$api.host+"/mSms/MemberPointsOutExchangeOrder/Check",
          action: "helpExchange"
        },
        {
          img: "images/3_08.png",
          text: "帮注册",
          // link: "/mSms/helpRegister",
          link: this.$api.host + "/mSms/Member/Register",
          hide_border: true
        }
      ],
      work_bench_item4: [
        {
          img: "images/20_07.png",
          text: "积分核销",
          // link: "/mSms/pointsCheckSheet"
          link: this.$api.host + "/mSms/PrizeStockOutProductOrder/Index"
        },
        {
          img: "images/2_10.png",
          text: "优惠券核销",
          hide_border: true,
          action: "checkCoupon"
        }
      ],
      work_bench_item5: [
        {
          img: "images/20_14.png",
          text: "门店会员",
          // link: "/mSms/memberList"
          link: this.$api.host + "/mSms/Member/Index"
        },
        {
          img: "images/1_32.png",
          text: "公告信息",
          // link: "/mSms/noticeCenter",
          link: this.$api.host + "/mSms/ShopNotice/Index",
          hide_border: true
        }
      ],
      work_bench_item6: [
        {
          img: "images/31_07.png",
          text: "我的红包",
          // link: "/Gms/Cc/PassageUserCashData/Index"
          link: this.$api.host + "/mCc/ShopCashInOrder/Index"
        },
        {
          img: "images/31_11.png",
          text: "红包记录",
          // link: "/Gms/Cc/PassageUserCashDataLog/Index",
          link: this.$api.host + "/mCc/PassageUserCashDataLog/Index",
          hide_border: true
        },
        {
          img: "images/31_07.png",
          text: "我的积分",
          link: "/BoyueGms/Pc/PassageUserPointsData/Index"
        },
        {
          img: "images/31_11.png",
          text: "积分记录",
          link: "/BoyueGms/Pc/PassageUserPointsDataLog/Index"
        }
      ]
    };
  },
  computed: {},

  async created() {
    this.wxJsSdk();

    var urlPassUser = this.$appBox.getPassageUser();
    if (urlPassUser == null) {
      this.passageUser = "";
    } else {
      this.passageUser = this.$appBox.getPassageUser();
      console.log(this.passageUser, "this.passageUser");
      console.log("this.passageUser=====>", this.passageUser);
      if (
        this.passageUser.PassageUserType == 81 ||
        this.passageUser.PassageUserType == 82
      ) {
        const workBenchUrl = "/Sms/Workbench";
        const bindWechatUrl = "/Sms/PassageUser/BindWechat";
        await passageUserManager.checkPassageUserData(
          this,
          workBenchUrl,
          bindWechatUrl
        );
      } else if (
        this.passageUser.PassageUserType == 51 ||
        this.passageUser.PassageUserType == 52
      ) {
        const workBenchUrl = "/Dms/Workbench";
        const bindWechatUrl = "/Dms/PassageUser/BindWechat";
        await passageUserManager.checkPassageUserData(
          this,
          workBenchUrl,
          bindWechatUrl
        );
      }
    }
  },

  methods: {
    // 获取jssdk
    wxJsSdk() {
      console.log(location.href, "location.origin");
      var sdkData = {
        uOpenId: "8659662804444e4b9ff929bb78b3da21",
        url: location.href
      };
      WxjsSdk.wxJsSdk(sdkData).then(res => {
        this.$msg.hideLoading();
        wx.config({
          debug: false, // true,// 开启调试模式
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录1
          // 必填，需要使用的JS接口列表
          jsApiList: ["scanQRCode"]
        });
      });
    },
    goGuideRightsPage() {
      this.$router.push("/mGms/GuideUserLevel");
    },
    goPage(link) {
      if (link) {
        window.location = this.$api.host + link;
        this.$toast({
          type: "loading",
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: "spinner",
          message: "加载中"
        });
      }
    },
    checkin() {
      this.showActionSheet = true;
      this.actionTitle = this.actionSheet1.title;
      this.actionList = this.actionSheet1.actions;
    },
    checkout() {
      this.showActionSheet = true;
      this.actionTitle = this.actionSheet2.title;
      this.actionList = this.actionSheet2.actions;
    },
    checkCoupon() {
      this.showActionSheet = true;
      this.actionTitle = this.actionSheet3.title;
      this.actionList = this.actionSheet3.actions;
    },
    helpExchange() {
      this.showActionSheet = true;
      this.actionTitle = this.actionSheet4.title;
      this.actionList = this.actionSheet4.actions;
    },
    onSelect(item) {
      console.log(item);
      if (item.url) {
        if (item.url.indexOf("http") == -1) {
          this.$router.push(item.url);
        } else {
          window.location = item.url;
          this.$toast({
            type: "loading",
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: "spinner",
            message: "加载中"
          });
        }
      }
    },
    onClickScanBtn() {
      wx.scanQRCode({
        needResult: 0,
        scanType: ["qrCode"],
        success: res1 => {
          console.log("开始扫码", res1);
        },
        fail: err => this.err_toast(err)
      });
    }
  }
};
